import { render, staticRenderFns } from "./ProductCategoryTableModal.vue?vue&type=template&id=96b44040&"
import script from "./ProductCategoryTableModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports